import { addQueryParams } from "../../utils/helpers";
import { http, formDataHttp } from "./http";

const getRequest = (url, query = {}, signal, config = {}) => {
  const requestUrl = addQueryParams(url, query);
  return http.get(requestUrl, {
    ...config,
    signal,
  });
};

const postRequest = (url, data = {}, config = {}) => {
  return http.post(url, data, config);
};  

const postFormDataRequest = (url, data = {}, config = {}) => {
  return formDataHttp.post(url, data, config);
};



const putRequest = (url, data = {}, config = {}) => {
  return http.put(url, data, config);
};

const putFormDataRequest = (url, data = {}, config = {}) => {
  return formDataHttp.put(url, data, config);
};

const deleteRequest = (url, config = {}) => {
  return http.delete(url, config);
};

export { getRequest, postRequest, putRequest, deleteRequest, postFormDataRequest, putFormDataRequest };  
